import { call } from 'redux-saga/effects';
import { APIS } from '../../_config';
import { CallApi } from '../api/callApi';


export function* getFrequencyList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_FREQUENCY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerType(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_TYPE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveScheduler(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.MAINTENANCE_CALENDER.SAVE_SCHEDULER, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteScheduler(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.MAINTENANCE_CALENDER.DELETE_SCHEDULER + "?SchedulerID=" + data.schedulerID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* uploadImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.MAINTENANCE_CALENDER.UPLOAD_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* uploadAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.MAINTENANCE_CALENDER.UPLOAD_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getSchedulerImages(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.GET_SCHEDULER_IMAGES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteSchedulerFiles(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.MAINTENANCE_CALENDER.DELETE_SCHEDULER_FILES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* exportToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.EXPORT_TO_PDF, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* exportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.MAINTENANCE_CALENDER.EXPORT_TO_XLS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}